module.exports = __webpack_public_path__ + "static/img/user4.67af64b6.png";